// Whether the browser is drawing without a graphics card: hardware
// acceleration turned off, or a GPU it has blocklisted, so WebGL runs on the
// CPU (SwiftShader in Chrome and Edge, llvmpipe on Linux, Microsoft Basic
// Render Driver on Windows). The viewer then runs at a frame or two a second
// on any preset, and src/ui/gpunotice.js says why.
//
// Read from the renderer string WebGL reports. Firefox gives the name through
// gl.RENDERER and warns when WEBGL_debug_renderer_info is asked for, so that
// is read first; Chrome and Safari answer "WebKit WebGL" there and need the
// extension. ?gpu=software stands in a software renderer for checks.

const SOFTWARE = /swiftshader|llvmpipe|softpipe|basic render|software rasterizer|mesa offscreen/i;

export function isSoftwareRenderer(name) {
  return SOFTWARE.test(String(name || ''));
}

// The renderer string from a throwaway context, released at once. Empty when
// WebGL is not there.
export function readGpuRenderer() {
  try {
    const canvas = document.createElement('canvas');
    const gl = canvas.getContext('webgl2') || canvas.getContext('webgl');
    if (!gl) return '';
    let name = gl.getParameter(gl.RENDERER);
    if (!name || /^webkit webgl$/i.test(name)) {
      const info = gl.getExtension('WEBGL_debug_renderer_info');
      if (info) name = gl.getParameter(info.UNMASKED_RENDERER_WEBGL);
    }
    const lose = gl.getExtension('WEBGL_lose_context');
    if (lose) lose.loseContext();
    return String(name || '');
  } catch {
    return '';
  }
}

function pageSoftwareRendering() {
  if (typeof window === 'undefined' || typeof document === 'undefined' || !window.WebGLRenderingContext) return false;
  try {
    if (new URLSearchParams(window.location.search).get('gpu') === 'software') return true;
  } catch (e) {}
  return isSoftwareRenderer(readGpuRenderer());
}

// This page, read once when the module loads.
export const SOFTWARE_RENDERING = pageSoftwareRendering();
